import m from 'mithril'
import {
    Dialog,
    TextBox,
    Button
} from 'components'
import {
    Module,
} from "app/models"
import Swal from 'sweetalert2'

class EditDialog {
    constructor(vnode) {
        this.model = vnode.attrs.model
        
        // 保存初始狀態用於檢測修改
        this.originalState = {
            name: this.model.name,
            prompt: this.model.prompt,
            welcome: this.model.welcome,
            is_context: this.model.is_context,
            is_web: this.model.is_web,
            is_background: this.model.is_background
        };
    }
 
    // 檢查是否有修改
    hasChanges() {
        return this.model.name !== this.originalState.name ||
               this.model.prompt !== this.originalState.prompt ||
               this.model.welcome !== this.originalState.welcome ||
               this.model.is_context !== this.originalState.is_context ||
               this.model.is_web !== this.originalState.is_web ||
               this.model.is_background !== this.originalState.is_background;
    }

    close(event, value) {
        if (this.hasChanges()) {
            Swal.fire({
                title: '有未儲存的變更',
                text: '確定要放棄變更並關閉嗎？',
                showDenyButton: true,
                confirmButtonText: '儲存',
                denyButtonText:  '放棄',
                showCancelButton: true,
                cancelButtonText: '取消',
                background: '#333',
                color: '#FFFFFF',
                borderRadius: '15px',
            }).then((result) => {
                if (result.isConfirmed) {
                    // 使用者選擇儲存
                    this.save();
                } else if (result.isDenied) {
                    // 使用者選擇放棄變更
                    setTimeout(() => {
                        Dialog.close(false)
                        m.redraw()
                    }, 200)
                }
                // 如果使用者取消，則不做任何動作
            });
        } else {
            // 沒有修改，直接關閉
            setTimeout(() => {
                Dialog.close(false)
                m.redraw()
            }, 200)
        }
    }

    save() {
        if (this.model.is_default) {
            Module.unlike(this.model).then((response) => {
                Dialog.close(true)
            })
        } else {
            this.model.save().then((response) => {
                Dialog.close(true)
            })
        }

    }

    view({
        attrs
    }) {
        return m('.modal-dialog.modal-dialog-centered', [
            m('.modal-content', {
                style: {
                    borderRadius: '15px',
                    border: 'none',
                    backgroundColor: '#333',
                    color: '#FFFFFF'
                }
            }, [
                m('.modal-header.py-3', {
                    style: {
                        background: '#414141',
                        borderRadius: '15px 15px 0 0',
                        border: 'none'
                    }
                }, [
                    m('h5.modal-title', {
                        style: {
                            color: 'white'
                        }
                    }, [
                        m('strong', this.model.name)
                    ]),
                    m('.btn.close', {
                        onclick: this.close.bind(this),
                        style: {
                            color: 'white',
                            opacity: 0.8,
                            transition: 'all 0.2s ease'
                        }
                    }, [
                        m('span', m.trust('&times;'))
                    ])
                ]),
                m(".modal-body", {
                    style: {
                        padding: '25px',
                        backgroundColor: '#333'
                    }
                }, [
                    m('.container-fluid', [
                        m('.row', [
                            (!this.model.is_default) ?
                                m('.col-12',
                                    m(TextBox, {
                                        oninput: (e) => {
                                            this.model.name = e.target.value
                                        },
                                        value: this.model.name,
                                        type: 'text',
                                        label: "名稱",
                                        required: true,
                                        style: {
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                            backgroundColor: '#414141',
                                            color: '#FFFFFF'
                                        },
                                        labelStyle: {
                                            color: '#FFFFFF'
                                        },
                                        validate: () => {
                                            this.model.valid('name')
                                        },
                                        error: this.model.error('name'),
                                    })
                                ) : "",
                            (!this.model.is_default) ?
                                m('.col-12.pt-4',
                                    m(".form-group", [
                                        m("label.mb-2", {
                                            style: {
                                                fontWeight: '600',
                                                color: '#FFFFFF'
                                            }
                                        }, "提示詞"),
                                        m("i.fas fa-circle-info.ms-2", {
                                            style: {
                                                fontSize: "1rem",
                                                color: "#FFF",
                                                cursor: "pointer"
                                            },
                                            onclick: (e) => {
                                                e.preventDefault();
                                                chrome.tabs.create({
                                                    url: "https://robot.apeai.com.tw/ai-prompt/"
                                                });
                                            }
                                        }),
                                        [
                                            m("textarea", {
                                                oninput: (e) => {
                                                    this.model.prompt = e.target.value
                                                },
                                                class: 'mt-0 form-control',
                                                placeholder: "你要扮演...你的任務是...請用...的方式回答問題",
                                                style: {
                                                    borderRadius: '8px',
                                                    minHeight: '120px',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                                    padding: '12px',
                                                    backgroundColor: '#414141',
                                                    color: '#FFFFFF',
                                                    border: 'none'
                                                },
                                                value: this.model.prompt,
                                            })
                                        ]
                                    ]),
                                ) : "",
                            
                           
                            

                            m('.w-100'),
                        ])
                    ])
                ]),
                m('.modal-footer', {
                    style: {
                        borderTop: '1px solid #414141',
                        padding: '16px 25px',
                        backgroundColor: '#333'
                    }
                }, [
                    m(Button, {
                        class: 'btn-success',
                        style: {
                            backgroundColor: '#333',
                            color: '#FFFFFF',
                            borderRadius: '8px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                            border: '1px solid #3498db',
                            padding: '8px 20px',
                            fontWeight: '600',
                            transition: 'all 0.3s ease'
                        },
                        onclick: (e) => {
                            e.preventDefault()
                            this.save()
                        }
                    }, "儲存"),
                    (this.model.id == 0) ? "" :
                        m(Button, {
                            class: 'btn-danger',
                            style: {
                                backgroundColor: '#333',
                                color: '#FFFFFF',
                                borderRadius: '8px',
                                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                                border: '1px solid #ef473a',
                                padding: '8px 20px',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                marginLeft: '10px'
                            },
                            onclick: (e) => {
                                e.preventDefault()
                                Swal.fire({
                                    title: "確定要刪除嗎？",
                                    showDenyButton: true,
                                    confirmButtonText: "儲存",
                                    denyButtonText: "刪除",
                                    background: '#333',
                                    color: '#FFFFFF',
                                    borderRadius: '15px',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                    } else if (result.isDenied) {
                                        if (this.model.is_default) {
                                            Module.deleteDefdult(this.model.id).then((response) => {
                                                Dialog.close(true)
                                            })
                                        } else {
                                            Module.deleteModule(this.model.id).then((response) => {
                                                Dialog.close(true)
                                            })
                                        }
                                    }
                                });
                            }
                        }, "刪除"),
                    m(Button, {
                        class: 'btn-outline-secondary',
                        style: {
                            borderRadius: '8px',
                            padding: '8px 20px',
                            fontWeight: '600',
                            transition: 'all 0.3s ease',
                            backgroundColor: 'transparent',
                            marginLeft: '10px',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF'
                        },
                        onclick: this.close.bind(this)
                    }, "關閉")
                ])
            ])
        ])
    }
}

export default EditDialog